var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lightbulb",
    clipPath: "url(#clip0_945_17596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.37496 15.3743C6.37496 15.7285 6.65829 16.0827 7.08329 16.0827H9.91663C10.3416 16.0827 10.625 15.7285 10.625 15.3743V14.666H6.37496V15.3743ZM8.49996 1.91602C5.73746 1.91602 3.54163 4.11185 3.54163 6.87435C3.54163 8.57435 4.39163 10.0618 5.66663 10.9118V12.541C5.66663 12.8952 5.94996 13.2493 6.37496 13.2493H10.625C11.05 13.2493 11.3333 12.8952 11.3333 12.541V10.9118C12.6083 9.99102 13.4583 8.50352 13.4583 6.87435C13.4583 4.11185 11.2625 1.91602 8.49996 1.91602Z",
    fill: "#6366F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_945_17596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutions);
export default __webpack_public_path__ + "static/media/solutions.b170a4423f8ed9490da6a864d7492727.svg";
export { ForwardRef as ReactComponent };